import { Controller } from "@hotwired/stimulus"

// Swaps the scan-type-specific UI on the new pantry scan page: tips list,
// dropzone copy, and submit-button label all match the active mode. Item
// locations are always inferred server-side from each item's name.
export default class extends Controller {
  static targets = [
    "shelfTips",
    "receiptTips",
    "dropzoneTitle",
    "dropzoneHint",
    "submitLabel"
  ]

  change(event) {
    const value = event?.target?.value
    if (value !== "shelf" && value !== "receipt") return
    this.#apply(value)
  }

  #apply(scanType) {
    const isReceipt = scanType === "receipt"

    if (this.hasShelfTipsTarget) this.shelfTipsTarget.classList.toggle("hidden", isReceipt)
    if (this.hasReceiptTipsTarget) this.receiptTipsTarget.classList.toggle("hidden", !isReceipt)

    if (this.hasDropzoneTitleTarget) {
      this.dropzoneTitleTarget.textContent = isReceipt ? "Snap or upload a receipt" : "Tap to take photos"
    }
    if (this.hasDropzoneHintTarget) {
      this.dropzoneHintTarget.textContent = isReceipt
        ? "Camera roll works too — long receipts can be split into multiple photos."
        : "Multiple shots of the same area help accuracy."
    }
    if (this.hasSubmitLabelTarget) {
      this.submitLabelTarget.textContent = isReceipt ? "Read receipt" : "Scan inventory"
    }
  }
}
